import React from 'react';

import Tooltip from '@atlaskit/tooltip';

export const ConditionalTooltip = ({
	withTooltip,
	content,
	children,
}: {
	withTooltip: boolean;
	content: string;
	children: React.ReactNode;
}) => {
	return withTooltip ? <Tooltip content={content}>{children}</Tooltip> : children;
};
